import { render } from "./LinksItem.vue?vue&type=template&id=cfc3fa7c&scoped=true&ts=true"
import script from "./LinksItem.vue?vue&type=script&lang=ts"
export * from "./LinksItem.vue?vue&type=script&lang=ts"

import "./LinksItem.vue?vue&type=style&index=0&id=cfc3fa7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc3fa7c"]])

export default __exports__